/* eslint-disable max-len */
import React from "react";
import { Loading, Modal } from "seed/helpers";
import WSManager from "components/util/ws";
import l from "components/util/l";

import HelpMessage from 'components/util/helpers/HelpMessage';
import Table from "components/collections/Table";
import Settings from "components/collections/forms/Settings";
import CollectionFormCreate from "components/collections/forms/CollectionFormCreate";
import CollectionFormEdit from "components/collections/forms/CollectionFormEdit";
import CollectionFormImport from "components/collections/forms/CollectionFormImport";
import ColumnFormCreate from "components/collections/forms/ColumnFormCreate";
import ColumnFormEdit from "components/collections/forms/ColumnFormEdit";
import ScrollArrow from "components/util/helpers/ScrollArrow";
import PermissionForm from "components/collections/forms/PermissionForm";
import CollectionTab from "components/collections/Collections.sub.tab.view";
import "styles/css/collections/Collections.css";

const createTableMessage = "Crea tablas personalizadas para guardar información del proceso%CA143";
const createFolderMessage = "Crea carpetas para guardar documentos y archivos del proceso%CA144";
const importExcelDataMessage = "Importa datos desde un archivo Excel para integrarlos en tu proceso%CA145";

const CollectionsView = ({
  tableRef,
  flow,
  activeCollectionId,
  collectionRoomName,
  height,
  embeddingStatus,
  collections,
  collectionOptions,
  primaryKey,
  columns,
  rows,
  pageNum,
  pageSize,
  totalPages,
  query,
  filters,
  search,
  sorting,
  isDeveloper,
  isReadOnly,
  isEditingTab,
  isLoading,
  showTabs,
  showPermissions,
  showManageCollections,
  showAdd,
  showDelete,
  collectionCreateModal,
  collectionEditModal,
  collectionImportModal,
  columnCreateModal,
  columnEditModal,
  settingsModal,
  permissionModal,
  setActiveCollectionId,
  setIsEditingTab,
  onSaveCollection,
  onEditCollection,
  onChangeCollectionName,
  onClickCreateCollection,
  onClickCloneCollection,
  onClickChangeTab,
  onClickDeleteCollection,
  onClickDeleteRow,
  onClickDeleteMultipleRows,
  onClickClearData,
  onClickImport,
  onClickExport,
  onClickDownloadZip,
  onClickCell,
  onCollectionMessage,
  onClickOpenCollectionCreateModal,
  onClickCloseCollectionCreateModal,
  onClickOpenCollectionEditModal,
  onClickCloseCollectionEditModal,
  onClickOpenCollectionImportModal,
  onClickCloseCollectionImportModal,
  onClickOpenColumnCreateModal,
  onClickCloseColumnCreateModal,
  onClickOpenColumnEditModal,
  onClickCloseColumnEditModal,
  onClickOpenSettingsModal,
  onClickCloseSettingsModal,
  onClickOpenPermissionModal,
  onClickClosePermissionModal,
  pushColumnOperation,
  pushRowOperation,
  updateSearch,
  updateFilters,
  updateQuery,
  updateSorting,
  updatePage,
  refetchCollections,
}) => (
  <div id="tables" class="px-3 px-sm-4 py-1 d-flex flex-column justify-content-between w-100 h-100">

    <div id="tables-body" className="w-auto overflow-auto" >

      {!activeCollectionId && !isLoading && (
        <div className="w-100 h-100" id="no-tables-content">
          <div className="d-flex flex-column justify-content-center align-items-center w-100 h-75">
            <i className="fas fa-table mb-1 fa-3x"></i><br />
            <h3 className="text-muted text-center">
              {
                collections && collections.length > 0 && !isReadOnly
                  ? <span>{l("No se ha seleccionado ninguna tabla%CA001")}</span>
                  : <span>
                    <span className="mb-1">{l("Aún no tienes tablas creadas%CA002")}<br /></span>
                    <small>{l("Utiliza las tablas para guardar datos y utilizarlos en tu solución%CA003")}</small>
                  </span>
              }
            </h3>
            {
              collections && collections.length == 0 && !isLoading && !isReadOnly &&
              <div id="no-table-ctas" className="d-flex justify-content-center">
                <div>

                  <HelpMessage message={l(createTableMessage)}>
                    <button
                      id="create-empty-table-dropdown"
                      type="button"
                      className="btn btn-primary mt-3 px-4"
                      onClick={onClickCreateCollection}
                    >
                      <i className="fas fa-plus mr-2"></i>
                      {l("Crear tabla%CA004")}
                    </button>
                  </HelpMessage>

                  {/* Temp hide
                  <div className="dropdown-menu" aria-labelledby="create-empty-table-dropdown">
                    <HelpMessage message={l(createTableMessage)}>
                      <Link
                        to={`/collection/create?type=TABLE`}
                        class="dropdown-item"
                        style={{ cursor: "pointer" }}
                      >
                        <div>
                          <i class="tio-table dropdown-item-icon"></i>
                          <span>Crear tabla</span>
                        </div>
                      </Link>
                    </HelpMessage>
                    <HelpMessage message={l(createFolderMessage)}>
                      <Link
                        to={`/collection/create?type=LIST`}
                        class="dropdown-item"
                        style={{ cursor: "pointer" }}
                      >
                        <div>
                          <i class="fas fa-list dropdown-item-icon"></i>
                          <span>Crear lista</span>
                        </div>
                      </Link>
                    </HelpMessage>
                    <HelpMessage message={l(createFolderMessage)}>
                      <Link
                        to={`/collection/create?type=DOCUMENT`}
                        class="dropdown-item"
                        style={{ cursor: "pointer" }}
                      >
                        <div>
                          <i class="tio-folder dropdown-item-icon"></i>
                          <span>Crear carpeta de archivos</span>
                        </div>
                      </Link>
                    </HelpMessage>
                  </div>
                  */}

                </div>
              </div>
            }
          </div>
        </div>
      )}

      {
        function () {

          const activeCollection = collections.find(collection => collection.id == activeCollectionId);
          if (isReadOnly) return;
          if (!activeCollection) return;

          return <div id="table-title" className="d-flex align-items-center pt-1">
            <h2
              className='my-auto'
              onClick={onClickOpenCollectionEditModal}>
              {activeCollection?.uiSettings?.label ?? activeCollection.name}
            </h2>
            <div className="ml-1">
              <span
                type="button"
                className="btn-lighter m-0 edit-btn"
                onClick={onClickOpenCollectionEditModal}>
                <i className="fas fa-pen"></i>
              </span>
            </div>

            {
              isDeveloper &&
              <span className="ml-1">ID: {activeCollection.id}</span>
            }

            {
              isDeveloper && embeddingStatus != null &&
              <div className="ml-2">
                <span className="badge badge-pill badge-primary d-flex align-items-center">
                  <i className="fas fa-spinner fa-spin mr-2"></i>
                  {l("Actualizando%CA006")}... 
                </span>
              </div>
            }

          </div>

        }()
      }


      {activeCollectionId && (
        <div style={{ marginTop: "1.15rem" }}>
          {
            function () {

              const activeCollection = collections.find(collection => collection.id == activeCollectionId);
              if (!activeCollection) return;

              return <Table
                ref={tableRef}
                flow={flow}
                activeCollection={activeCollection}
                primaryKey={primaryKey}
                values={rows}
                structure={columns}
                pageNum={pageNum}
                pageSize={pageSize}
                totalPages={totalPages}
                query={query}
                filters={filters}
                sorting={sorting}
                search={search}
                height={height}
                collections={collections}
                collectionOptions={collectionOptions}
                checkValidation={true}
                useCustomPagination={true}
                useCustomSearch={true}
                useCustomFilters={true}
                useCustomImport={true}
                useCustomExport={true}
                useCustomSorting={true}
                showExport={!isReadOnly}
                showImport={!isReadOnly}
                showOptions={!isReadOnly}
                showSearch={!isReadOnly}
                showFilters={!isReadOnly}
                showSorting={!isReadOnly}
                showAdd={showAdd && !isReadOnly}
                showDelete={showDelete && !isReadOnly}
                showPermissions={showPermissions}
                showManageCollections={showManageCollections}
                isReadOnly={isReadOnly || !showTabs}
                isLoading={isLoading}
                onClickCloneCollection={onClickCloneCollection}
                onClickDeleteCollection={() => onClickDeleteCollection(activeCollection.id)}
                onClickClearData={onClickClearData}
                onClickDeleteRow={onClickDeleteRow}
                onClickDeleteMultipleRows={onClickDeleteMultipleRows}
                onClickImport={onClickImport}
                onClickExport={onClickExport}
                onClickDownloadZip={onClickDownloadZip}
                onClickCell={onClickCell}
                onClickOpenCollectionEditModal={onClickOpenCollectionEditModal}
                onClickOpenColumnCreateModal={onClickOpenColumnCreateModal}
                onClickOpenColumnEditModal={onClickOpenColumnEditModal}
                onClickOpenPermissionModal={onClickOpenPermissionModal}
                pushColumnOperation={pushColumnOperation}
                pushRowOperation={pushRowOperation}
                updateSearch={updateSearch}
                updateFilters={updateFilters}
                updateQuery={updateQuery}
                updateSorting={updateSorting}
                updatePage={updatePage}
                refetchCollections={refetchCollections}
              />;

            }()
          }

        </div>
      )}

    </div>

    {showTabs && collections.length > 0  && (
      <div id="tables-footer">
        <ScrollArrow scrollAmount={470} align="left" 
          rightButtonStyle={{fontSize: '1.24rem'}} leftButtonStyle={{fontSize: '1.24rem'}}>
        <div id="collection-tabs" className="d-flex align-items-baseline py-1 mr-1">

          {
            showManageCollections && <div>
              <button
                type="button"
                className="btn btn-outline-primary-white d-flex align-items-center px-2 py-0"
                onClick={onClickOpenSettingsModal}
              >
                <span className="py-2 px-1">
                  <i className="fas fa-cog"></i>
                </span>
              </button>
            </div>
          }

          {(showManageCollections || (!isReadOnly && collections?.length > 1)) && (collections ?? []).map((collection, index) => {

            if(activeCollectionId == collection.id && isEditingTab)
              return<div key={`collection-tab-${index}`}>
                <input
                  type="text"
                  className="form-control"
                  defaultValue={collection?.uiSettings?.label ?? collection.name}
                  onKeyDown={(e) => {
                    if (e.key == "Enter") {
                      setIsEditingTab(false);
                      onChangeCollectionName(collection, e.target.value);
                    }
                  }}
                  onBlur={(e) => {
                    setIsEditingTab(false);
                    onChangeCollectionName(collection, e.target.value);
                  }}
                />
              </div>;

            return <CollectionTab
              key={`collection-tab-${index}`}
              index={index}
              tableRef={tableRef}
              collection={collection}
              activeCollectionId={activeCollectionId}
              onClickTab={() => {
                if (activeCollectionId !== collection.id)
                  onClickChangeTab(collection.id);
              }}
              // onDoubleClickTab={() => setIsEditingTab(true)}
              showImport={!isReadOnly}
              showExport={!isReadOnly}
              showManageCollections={showManageCollections}
              showPermissions={showPermissions}
              isReadOnly={isReadOnly}
            />;

          })}

          {(showManageCollections || (!isReadOnly && collections?.length > 1)) && (
            <div id="add-collection-tab" className="d-flex align-items-center">

              <div class="dropdown">

                <button
                  id="create-table-dropdown"
                  class="btn collection-tab d-flex align-items-center dropdown-toggle pr-1 pl-1 py-1 ml-2"
                  type="button"
                  onClick={onClickCreateCollection}
                >
                  <span className="text-truncate px-2 py-1">
                    <i className="fas fa-plus mr-2 tab-icon"></i>
                    <span>{l("Crear tabla%CA004")}</span>
                  </span>
                </button>

                {/* Temp hide
                <div id="create-table-dropdown-content">
                  <div>
                    <div class="dropdown-menu" aria-labelledby="create-table-dropdown">

                      <StyleTag
                        content={`
                          #create-table-dropdown-sub:hover .dropdown-menu {
                            display: block;
                          }
                          #create-table-dropdown-submenu {
                            display: none;
                            position: absolute;
                            left: 100%;
                            top: 0;
                            z-index: 9999;
                          }
                        `}
                      />

                      <HelpMessage message={l(createTableMessage)}>
                        <Link
                          to={`/collection/create?type=TABLE`}
                          class="dropdown-item"
                          style={{ cursor: "pointer" }}
                        >
                          <div>
                            <i class="tio-table dropdown-item-icon"></i>
                            <span>Crear tabla</span>
                          </div>
                        </Link>
                      </HelpMessage>

                      <HelpMessage message={l(createFolderMessage)}>
                        <Link
                          to={`/collection/create?type=LIST`}
                          class="dropdown-item"
                          style={{ cursor: "pointer" }}
                        >
                          <div>
                            <i class="fas fa-list dropdown-item-icon"></i>
                            <span>Crear lista</span>
                          </div>
                        </Link>
                      </HelpMessage>

                      <HelpMessage message={l(createFolderMessage)}>
                        <Link
                          to={`/collection/create?type=DOCUMENT`}
                          class="dropdown-item"
                          style={{ cursor: "pointer" }}
                        >
                          <div>
                            <i class="tio-folder dropdown-item-icon"></i>
                            <span>Crear carpeta de archivos</span>
                          </div>
                        </Link>
                      </HelpMessage>

                      <hr className="my-3 mx-4" />

                      <HelpMessage message={l(importExcelDataMessage)}>
                        <Link
                          to={`/collection/import`}
                          class="dropdown-item"
                          style={{ cursor: "pointer" }}
                        >
                          <div>
                            <i class="tio-file-add dropdown-item-icon"></i>
                            <span>Importar excel</span>
                          </div>
                        </Link>
                      </HelpMessage>

                    </div>
                  </div>
                </div>
                */}
              </div>             
            </div>
          )}

        </div>
        </ScrollArrow>
      </div>
    )}

    {
      columnCreateModal &&
      <Modal
        width="600"
        height="550"
        flow={flow}
        collectionId={activeCollectionId}
        onSave={onEditCollection}
        component={ColumnFormCreate}
        onClose={onClickCloseColumnCreateModal}
        {...columnCreateModal}
      />
    }

    {
      columnEditModal &&
      <Modal
        width="600"
        height="550"
        flow={flow}
        collectionId={activeCollectionId}
        onSet={onEditCollection}
        component={ColumnFormEdit}
        onClose={onClickCloseColumnEditModal}
        {...columnEditModal}
      />
    }

    {
      collectionCreateModal &&
      <Modal
        width="600"
        height="570"
        flow={flow}
        onSave={onSaveCollection}
        component={CollectionFormCreate}
        onClose={onClickCloseCollectionCreateModal}
        {...collectionCreateModal}
      />
    }

    {
      collectionEditModal &&
      <Modal
        width="600"
        height="570"
        flow={flow}
        collectionId={activeCollectionId}
        setActiveCollectionId={setActiveCollectionId}
        onSet={onEditCollection}
        component={CollectionFormEdit}
        onClose={onClickCloseCollectionEditModal}
        {...collectionEditModal}
      />
    }

    {
      collectionImportModal &&
      <Modal
        width="600"
        height="550"
        flow={flow}
        collectionId={activeCollectionId}
        onSave={onEditCollection}
        component={CollectionFormImport}
        onClose={onClickCloseCollectionImportModal}
        {...collectionImportModal}
      />
    }

    {
      settingsModal &&
      <Modal
        width="600"
        height="550"
        flow={flow}
        refetchCollections={refetchCollections}
        component={Settings}
        onClose={onClickCloseSettingsModal}
        {...settingsModal}
      />
    }

    {
      permissionModal &&
      <Modal
        width="600"
        height="550"
        flowId={flow.id}
        collectionId={activeCollectionId}
        refetchCollections={refetchCollections}
        component={PermissionForm}
        onClose={onClickClosePermissionModal}
        {...permissionModal}
      />
    }

    <WSManager
      initialRoom={collectionRoomName}
      autoSuscribe={true}
      onMessageReceived={onCollectionMessage}
    />

  </div>
);

export default CollectionsView;